import { atom } from "recoil";

export const firstReceiptFormState = atom({
  key: "firstReceiptFormState",
  default: {},
  dangerouslyAllowMutability: true,
});

export const firstAnswerState = atom({
  key: "firstAnswerState",
  default: null,
  dangerouslyAllowMutability: true,
});

export const secondAnswerState = atom({
  key: "secondAnswerState",
  default: null,
  dangerouslyAllowMutability: true,
});

export const thirdAnswerState = atom({
  key: "thirdAnswerState",
  default: new Set(),
  dangerouslyAllowMutability: true,
});

export const receiptSubmitState = atom({
  key: "receiptSubmitState",
  default: true,
});

export const signFileState = atom({
  key: "signFileState",
  default: "",
  dangerouslyAllowMutability: true,
});

export const bankbookFileState = atom({
  key: "bankbookFileState",
  default: {},
  dangerouslyAllowMutability: true,
});

export const isDrawSignModalOpenState = atom({
  key: "isDrawSignModalOpenState",
  default: false,
});
